export function parseURLQuery(search: string) {
    const parameters: Record<string, string> = {};

    const searchParams = new URLSearchParams(search);
    for (const [originalKey, value] of searchParams.entries()) {
        const key = originalKey.replace(/\[\d*]$/, '');
        if (parameters[key]) {
            parameters[key] += `,${value}`;
        } else {
            parameters[key] = value;
        }
    }

    return parameters;
}

export type StringifyToURLQueryParams = ConstructorParameters<typeof URLSearchParams>[0];

export function stringifyToURLQuery(params: StringifyToURLQueryParams) {
    const searchParams = new URLSearchParams(params);
    return searchParams.toString();
}
